import { createRoot } from 'react-dom/client';

import 'styles/global.scss';
import { FrontOfficeApp } from './app';
import './lib/utils/i18n';

const container = document.getElementById('root');
const root = createRoot(container as Element);
root.render(<FrontOfficeApp />);
